import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import PlanTrip from "@/pages/PlanTrip";
import TripDetail from "@/pages/TripDetail";
import WishBoard from "@/pages/WishBoard";
import Feedback from "@/pages/Feedback";
import VerifyEmail from "@/pages/VerifyEmail";
import ResetPassword from "@/pages/ResetPassword";
import Guide from "@/pages/Guide";
import PreviewHome from "@/pages/PreviewHome";
import PrimaEDopo from "@/pages/PrimaEDopo";

const ProtectedRoute = ({ children }) => {
  const { user, initializing } = useAuth();
  if (initializing || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[#B79A5A] font-body">
        Loading...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const GuestOnly = ({ children }) => {
  const { user, initializing } = useAuth();
  if (initializing || user === null) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
};

function AppShell() {
  return (
    <div className="min-h-screen app-bg stars-bg font-body relative overflow-hidden">
      <div className="relative z-20">
        <Navbar />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/preview" element={<PreviewHome />} />
          <Route path="/login" element={<GuestOnly><Login /></GuestOnly>} />
          <Route path="/register" element={<GuestOnly><Register /></GuestOnly>} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/rest-password" element={<ResetPassword />} />
          <Route path="/guida" element={<Guide />} />
          <Route path="/guide" element={<Guide />} />
          <Route path="/prima-e-dopo" element={<PrimaEDopo />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/plan" element={<ProtectedRoute><PlanTrip /></ProtectedRoute>} />
          <Route path="/wishes" element={<ProtectedRoute><WishBoard /></ProtectedRoute>} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/trip/:id" element={<ProtectedRoute><TripDetail /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Footer />
      </div>

      <Toaster
        position="top-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "rgba(24,20,62,0.95)",
            border: "1px solid rgba(212,175,55,0.3)",
            color: "#EDE7D8",
          },
        }}
      />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <AuthProvider>
          <AppShell />
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
